export default __webpack_public_path__ + "static/media/overviewBannerMobile.67315418.png";